import { Calendar, Col, Skeleton } from 'antd'
import React from 'react'
import { deviceDetect } from 'react-device-detect'
import CustomRow from '../../reusable-components/CustomRow'
import './utils/style.css'
import { useSelector } from 'react-redux'

const AvailabilityCalendar = ({ dateCellRender, onPanelClick, loading, panelValue, setPanelValue }) => {
  const availability = useSelector((state) => state.availability.data)

  return (
    <CustomRow justify='center'>
      <Col span={24}>
        <Calendar
          className='availability-calendar'
          value={panelValue}
          onPanelChange={(newValue) => !loading && setPanelValue(newValue)}
          fullscreen={deviceDetect().isMobile ? false : true}
          fullCellRender={deviceDetect().isMobile ? null : dateCellRender}
          style={{ borderRadius: 20 }}
          disabledDate={(current) => loading}
          onSelect={(date, info) => {
            if (!loading && info.source === 'date') {
              onPanelClick(date)
            }
          }}
        />
      </Col>
    </CustomRow>
  )
}

export default AvailabilityCalendar
